import { render, staticRenderFns } from "./DialogRealizadoDetalhamentoCategoriaAgrupada.vue?vue&type=template&id=1f2204e0"
import script from "./DialogRealizadoDetalhamentoCategoriaAgrupada.vue?vue&type=script&lang=js"
export * from "./DialogRealizadoDetalhamentoCategoriaAgrupada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports